// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);
require("component-leaflet-map");
require("component-responsive-frame/child");

//get access to Leaflet and the map
const element = document.querySelector("leaflet-map");
const L = element.leaflet;
const map = element.map;

const cases = {
  cases1: "#feedde",
  cases2: "#fdbe85",
  cases3: "#fd8d3c",
  cases4: "#e6550d",
  cases5: "#a63603"
};

const deaths = {
  deaths1: "#eff3ff",
  deaths2: "#bdd7e7",
  deaths3: "#6baed6",
  deaths4: "#3182bd",
  deaths5: "#08519c"
};


var markers = [];
var markergroup = L.featureGroup();

var zoomView = window.innerWidth > 768 ? 7 : 6;

map.setView(new L.LatLng(47.307538, -120.182643), zoomView);

window.course.forEach(function(data) {
  var caseClass;
  var deathClass;

  if (data.NumCases < 5 ) {
    caseClass = "cases0";
  } else if (data.NumCases >= 5 && data.NumCases <= 25.0) {
    caseClass = "cases1";
  } else if (data.NumCases > 25.0 && data.NumCases <= 50.0) {
    caseClass = "cases2";
  } else if (data.NumCases > 50.0 && data.NumCases <= 75.0) {
    caseClass = "cases3";
  } else if (data.NumCases > 75.0 && data.NumCases <= 100.0) {
      caseClass = "cases4";
  } else { caseClass = "cases5"; }


  if (data.NumDeaths === 0.0 ) {
    deathClass = "deaths0";
  } else if (data.NumDeaths > 0 && data.NumDeaths <= 5) {
    deathClass = "deaths1";
  } else if (data.NumDeaths > 5 && data.NumDeaths <= 10) {
    deathClass = "deaths2";
  } else if (data.NumDeaths > 10 && data.NumDeaths <= 15) {
    deathClass = "deaths3";
  } else if (data.NumDeaths > 15 && data.NumDeaths <= 20) {
    deathClass = "deaths4";
  } else { deathClass = "deaths5"; }


  var marker = L.marker([data.LAT, data.LONG], {
    icon: L.divIcon({
      className: `icon NUM${data.License_Number} ${caseClass} ${deathClass}`
    })
  });

  // var html = `
  //   <b>${data.Facility_Name}</b><br>
  // `;




  // marker.bindPopup(html);
  markers.push(marker);
  marker.addTo(markergroup);
});

markergroup.addTo(map);
map.scrollWheelZoom.disable();



// var casesKey = document.querySelector("#cases");
// casesKey.querySelectorAll(".ea");

var allMarkers = document.querySelectorAll(".icon");
var allDropItems = document.querySelectorAll(".item");
var textInput = document.getElementById("myInput");
var clearInput = document.querySelector(".fa-times-circle");


allMarkers.forEach(el => el.addEventListener('click', () => {
  document.querySelector("#instruc").classList.remove('show');
  document.querySelectorAll(".fac").forEach(el => el.classList.remove('show'));
  document.querySelectorAll(".icon").forEach(el => el.classList.remove('selected'));
  textInput.value = '';
  var allClasses = el.classList;
  var markerID;

  allClasses.forEach(name => {
   if (name.includes("NUM")) {
     markerID = name;
   } else {}
  });

  document.getElementById(markerID).classList.add('show');
  el.classList.add('selected');
}));



clearInput.addEventListener('click', () => {
  textInput.value = '';
  document.querySelectorAll(".fac").forEach(el => el.classList.remove('show'));
  document.querySelector("#instruc").classList.add('show');
  document.querySelectorAll(".icon").forEach(el => el.classList.remove('selected'));
  allDropItems.forEach(el => el.classList.add('hide'));
  clearInput.classList.remove('selected');
});

allDropItems.forEach(el => el.addEventListener('click', () => {
  document.querySelector("#instruc").classList.remove('show');
  document.querySelectorAll(".fac").forEach(el => el.classList.remove('show'));
  document.querySelectorAll(".icon").forEach(el => el.classList.remove('selected'));
  clearInput.classList.add('selected');
  allDropItems.forEach(el => el.classList.add('hide'));

  var itemText = el.textContent;
  itemText = itemText.trim();
  textInput.value = itemText;

  // console.log(itemText);


  var allClasses = el.classList;
  var markerID;

  allClasses.forEach(name => {
   if (name.includes("NUM")) {
     markerID = name;
   } else {}
  });

  document.getElementById(markerID).classList.add('show');
  document.querySelector(`.icon.${markerID}`).classList.add('selected');

}));

document.querySelector("#casesButton").addEventListener('click', () => runCases());
document.querySelector("#deathsButton").addEventListener('click', () => runDeaths());



var runCases = function() {
  document.querySelector("#casesButton").classList.add('selected');
  document.querySelector("#deathsButton").classList.remove('selected');
  document.querySelector('#cases').classList.remove('hide');
  document.querySelector('#deaths').classList.add('hide');
  document.querySelectorAll('.icon').forEach(el => el.classList.remove('hide'));
  document.querySelectorAll('.cases0').forEach(el => el.classList.add('hide'));
  allMarkers.forEach(el => {
    let allClasses = el.classList;
    let caseNum;

    allClasses.forEach(name => {
     if (name.includes("cases")) {
       caseNum = name;
     } else {}
    });

    el.style.backgroundColor = cases[caseNum];
  }); //allMarkers foreach
};

runCases();

var runDeaths = function() {
  document.querySelector('#cases').classList.add('hide');
  document.querySelector('#deaths').classList.remove('hide');
  document.querySelector("#casesButton").classList.remove('selected');
  document.querySelector("#deathsButton").classList.add('selected');
  document.querySelectorAll('.icon').forEach(el => el.classList.remove('hide'));
  document.querySelectorAll('.deaths0').forEach(el => el.classList.add('hide'));
  allMarkers.forEach(el => {
    let allClasses = el.classList;
    let deathNum;

    allClasses.forEach(name => {
     if (name.includes("deaths")) {
       deathNum = name;
     } else {}
    });

    el.style.backgroundColor = deaths[deathNum]
  }); //allMarkers foreach
};


// var input = document.getElementById("myInput");
// input.addEventListener("keyup", () => {
//   document.querySelectorAll(".button").forEach(el => el.classList.remove('active'));
//   myFunction(0);
// });
var input = document.getElementById("myInput");
input.addEventListener("keyup", () => filterFunction() );

var filterFunction = function() {
  var filter, ul, li, a, i;
  clearInput.classList.add('selected');

  filter = input.value.toUpperCase();
  div = document.getElementById("myDropdown");
  a = div.getElementsByClassName("item");
  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].classList.remove('hide');
    } else {
      a[i].classList.add('hide');
    }
  }
};
